var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(-2113 -481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M162.436,53.5h.011a.529.529,0,0,0,.517-.54l-.212-10.108a.529.529,0,0,0-.528-.518h-.011a.529.529,0,0,0-.517.54l.212,10.108A.529.529,0,0,0,162.436,53.5Zm3.094,0a.529.529,0,0,0,.528-.518l.212-10.108a.529.529,0,0,0-.517-.54h-.011a.529.529,0,0,0-.528.518L165,52.959a.529.529,0,0,0,.517.54Zm4.161-11.165a.531.531,0,0,0-.547.51l-.423,11.894a.65.65,0,0,1-.649.65H159.9a.656.656,0,0,1-.65-.669l-.423-11.875a.529.529,0,1,0-1.057.037l.423,11.857a1.71,1.71,0,0,0,1.708,1.708h8.176a1.7,1.7,0,0,0,1.706-1.689l.423-11.875a.528.528,0,0,0-.509-.547Zm1.065-2.115h-3.223V38.7a.529.529,0,0,0-.529-.529h-6.042a.529.529,0,0,0-.529.529v1.514h-3.225a.529.529,0,0,0,0,1.058h13.547a.529.529,0,1,0,0-1.058Zm-4.281,0h-4.984v-.985h4.984Z",
    transform: "translate(1961.018 445.209)",
    stroke: "#000",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 24,
    height: 24,
    transform: "translate(2113 481)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.e5eb98301b066a22d94130d35426fba6.svg";
export { ForwardRef as ReactComponent };